module.exports = __webpack_public_path__ + "static/code_vsk.60a1544c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code_vsk.jpg
// module id = q8fL
// module chunks = 0